import {Routes} from '@angular/router';
import {AuthGuard} from '../../guard/auth-guard/auth.guard';
import {RoleChildGuard} from '../../guard/auth-guard/role-child.guard';
import {Role} from '../../core/enums/role.enum';

export const analiseDocumentalAcoesAfirmativasRoutes: Routes = [
  {
    path: 'analise-documental-acoes-afirmativas',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Análise Documental de Ações Afirmativas',
      breadcrumb: [{label: 'Análise Documental de Ações Afirmativas', url: '/analise-documental-acoes-afirmativas'}],
    },
    children: [
      {
        path: '',
        loadComponent: () => import('./consultar-candidatos/consultar-candidatos.component').then((m) => m.ConsultarCandidatosAcoesAfirmativasComponent),
        data: {
          title: 'Análise Documental de Ações Afirmativas',
          roles: [Role.ANALISE_DOCUMENTAL_ACOES_AFIRMATIVAS_LISTAR],
          breadcrumb: [{label: 'Banca - Ações afirmativas', url: '/analise-documental-acoes-afirmativas'}],
        },
      },
      {
        path: 'relatorio',
        loadComponent: () => import('./relatorio/relatorio.component').then((m) => m.RelatorioAnaliseDocumentalAcoesAfirmativasComponent),
        data: {
          title: 'Relatório de Análise de Banca de Ações Afirmativas',
          roles: [Role.ANALISE_DOCUMENTAL_ACOES_AFIRMATIVAS_GERAR_RELATORIO],
          breadcrumb: [
            {label: 'Banca - Ações afirmativas', url: '/analise-documental-acoes-afirmativas'},
            {label: 'Relatório'},
          ],
        },
      },
      {
        path: ':inscricaoCicloId/editar',
        loadComponent: () => import('./editar-parecer/editar-parecer.component').then((m) => m.EditarParecerHu050Component),
        data: {
          title: 'Editar Parecer',
          roles: [Role.ANALISE_DOCUMENTAL_ACOES_AFIRMATIVAS_EDITAR_PARECER],
          breadcrumb: [{
            label: 'Banca - Ações afirmativas',
            url: '/analise-documental-acoes-afirmativas'
          }, {label: 'Editar Parecer'}]
        },
      },
      {
        path: ':inscricaoCicloId',
        loadComponent: () => import('./analisar-documentacao/analisar-documentacao.component').then((m) => m.AnalisarDocumentacaoAcoesAfirmativasComponent),
        data: {
          title: 'Análise Documental de Ações Afirmativas',
          roles: [Role.ANALISE_DOCUMENTAL_ACOES_AFIRMATIVAS_ANALISAR],
          breadcrumb: [
            {label: 'Banca - Ações afirmativas', url: '/analise-documental-acoes-afirmativas'},
            {label: 'Análise Documental de Ações Afirmativas'},
          ],
        },
      },
    ],
  },
];
